/* eslint-disable @typescript-eslint/no-require-imports */
/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react';
import {FlatList, Image, Text, TouchableOpacity, View} from 'react-native';
import {Loader} from '../Loader';
import {styles} from './styles';

export function ListNotification(props: any) {
  const {datas, handleMove} = props;
  const isLoading = false;
  return (
    <View>
      {isLoading ? (
        <Loader />
      ) : (
        <FlatList
          scrollEnabled={true}
          data={datas || []}
          renderItem={({item}: {item: any}) => (
            <TouchableOpacity
              style={[
                styles.ListItemInRow,
                !item.vu && styles.ColorBackgroundSeen,
              ]}
              onPress={() => {
                handleMove({item});
              }}>
              <View style={{flex: 1}}>
                <Text style={styles.titleBlue}>{item.dateCreation} </Text>
                <Text style={styles.titleBlue}>{item.titre} </Text>
                <Text style={styles.ListItemFont}>{item.message}</Text>
              </View>
              <View>
                <Image
                  style={styles.ListItemLogo}
                  source={require('../../../ressources/images/Arrow-Right.png')}
                />
              </View>
            </TouchableOpacity>
          )}
        />
      )}
    </View>
  );
}
